// extracted by mini-css-extract-plugin
export default {"sRoundButton":"DeleteButton_sRoundButton__izri9"};